export default [
    {
        //计量单位
        path: "/code/dw",
        name: "dw",
        component: () => import('../components/baseinfo/dw.vue'),
        meta: { keepAlive: false }
    },
    {
        //颜色
        path: "/code/color",
        name: "color",
        component: () => import('../components/baseinfo/color.vue'),
        meta: { keepAlive: false }
    },
    {
        //品牌
        path: "/code/pinpai",
        name: "pinpai",
        component: () => import('../components/baseinfo/pinpai.vue'),
        meta: { keepAlive: false }
    },
    {
        //入库类型
        path: "/code/itype",
        name: "itype",
        component: () => import('../components/baseinfo/itype.vue'),
        meta: { keepAlive: false }
    },
    {
        //出库类型
        path: "/code/otype",
        name: "otype",
        component: () => import('../components/baseinfo/otype.vue'),
        meta: { keepAlive: false }
    },
    {
        //规格
        path: "/code/kg",
        name: "kg",
        component: () => import('../components/baseinfo/kg.vue'),
        meta: { keepAlive: false }
    },
    {
        //结算方式
        path: "/code/moneytype",
        name: "moneytype",
        component: () => import('../components/baseinfo/money-type.vue'),
        meta: { keepAlive: false }
    }
]



// WEBPACK FOOTER //
// ./src/router/basecode-router.js